module.exports = __webpack_public_path__ + "img/qr-unready.6bc86953.png";